module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/产品2.7d2367db.png";